// min-width values
export enum Breakpoints {
  desktop = 1180,
  tablet = 1024,
  mobile = 320
}
